module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"ClientSection":"Client Area","support":"Support"}}')
  delete Component.options._Ctor
}
